import * as Context from "effect-app/Context"
import * as Effect from "effect-app/Effect"
import * as S from "effect-app/Schema"
import type * as Schema from "effect/Schema"
import * as SchemaTransformation from "effect/SchemaTransformation"

export const CategoryId = S.StringId
export type CategoryId = S.StringId

export class FastLaneDisabled extends S.Opaque<FastLaneDisabled, FastLaneDisabled.Encoded>()(
  S
    .TaggedStruct("Disabled", {
      availableFrom: S.NullOr(S.inputDate).withConstructorDefault
    })
    .annotate({ identifier: "FastLaneDisabled" })
) {}

export class FastLaneEnabled extends S.Opaque<FastLaneEnabled, FastLaneEnabled.Encoded>()(
  S.TaggedStruct("Enabled", {}).annotate({ identifier: "FastLaneEnabled" })
) {}

export const FastLaneState = S.Union([
  FastLaneEnabled,
  FastLaneDisabled
])

export type FastLaneState = typeof FastLaneState.Type

export class ConfiguratorCategory extends S.Opaque<ConfiguratorCategory, ConfiguratorCategory.Encoded>()(
  S
    .Struct({
      id: CategoryId.withConstructorDefault,
      title: S.NonEmptyString255,
      fastLane: FastLaneState
    })
    .annotate({ identifier: "ConfiguratorCategory" })
) {
  static readonly resolver = Context.Service<
    ConfiguratorCategoryFromId,
    (userId: CategoryId) => Effect.Effect<ConfiguratorCategory>
  >("ConfiguratorCategoryFromId")
}

export interface ConfiguratorCategoryFromId {
  readonly _: unique symbol
}

export const ConfiguratorCategoryFromId: Schema.Codec<ConfiguratorCategory, string, ConfiguratorCategoryFromId> =
  CategoryId
    .pipe(S.decodeTo(
      S.toType(ConfiguratorCategory),
      SchemaTransformation.transformEffect({
        decode: (id) => ConfiguratorCategory.resolver.use((resolve) => resolve(id)),
        encode: (category) => Effect.succeed(category.id)
      })
    ))

// codegen:start {preset: model}
//
export namespace FastLaneDisabled {
  export interface Encoded extends S.StructNestedEncoded<typeof FastLaneDisabled> {}
}
export namespace FastLaneEnabled {
  export interface Encoded extends S.StructNestedEncoded<typeof FastLaneEnabled> {}
}
export namespace ConfiguratorCategory {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorCategory> {}
}
//
// codegen:end
//
